export default __webpack_public_path__ + "static/img-asaas-ef405ad26439a010c4ed3da2acbd2408.png";